import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { P404Component } from './p404/p404.component';
import { P500Component } from './p500/p500.component';
import { NoInternetComponent } from './no-internet/no-internet.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared/shared.module';
import { AppService } from './app.service';
import { ApiService } from './pages/api.service';
import { ToastrModule } from 'ngx-toastr';
import { FileSaverModule } from 'ngx-filesaver';

@NgModule({
  declarations: [
    AppComponent,
    P404Component,
    P500Component,
    NoInternetComponent,
  ],
  imports: [
    FormsModule,
    HttpClientModule,
    BrowserModule,
    FileSaverModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthModule,
    SharedModule.forRoot(),
    ToastrModule.forRoot()

  ],
  providers: [AppService, ApiService],
  bootstrap: [AppComponent]
})
export class AppModule { }
